import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

export const fetchAllEvents = (id) => {
  return Api(`${endPoints.fetchAllEvents}/${id}`, null, requestType.GET);
};
export const fetchEventsDetailsById = (id) => {
  return Api(`${endPoints.EventsDetailsById}/${id}`, null, requestType.GET);
};
export const updateAppointmentById = (id, params) => {
  return Api(
    `${endPoints.updateAppointmentById}/${id}`,
    params,
    requestType.PUT
  );
};

export const fetchAllAppointments = (params) => {
  return Api(endPoints.fetchAllAppointments, params, requestType.POST);
};

export const updateAppointmentTime = (params) => {
  return Api(endPoints.updateAppointmentTime, params, requestType.POST);
};


//
export const fetchTimeSlots = params => {
  return Api(endPoints.timeslots, params, requestType.POST);
};

export const createAppointment = params => {
  return Api(endPoints.createAppointment, params, requestType.POST);
};

export const createClient = params => {
  return Api(endPoints.createClient, params, requestType.POST);
};

export const verifyOtp = params => {
  return Api(endPoints.verifyOtp, params, requestType.POST);
};

